import { SkyButton, SkyCard } from "@skypointcloud/skypoint-ui";
import { Lock, Trash2, UserCog } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useMsalAuth } from "@/hooks/useMsalAuth";

interface NoAccessPageProps {
  canAccessSettings?: boolean;
  /** Render a "ticket deleted" state instead of the generic Access Required copy. */
  deleted?: boolean;
}

export default function NoAccessPage({
  canAccessSettings = false,
  deleted = false,
}: NoAccessPageProps) {
  const navigate = useNavigate();
  const { getQueryString } = useMsalAuth();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-8 text-center">
      <SkyCard className="max-w-[500px] p-8 flex flex-col items-center gap-5">
        {deleted ? (
          <>
            <Trash2 className="w-16 h-16 text-gray-400 mb-3" />
            <span className="text-xl font-semibold text-gray-900 dark:text-gray-100">
              Ticket deleted
            </span>
            <span className="text-base text-gray-600 dark:text-gray-300 leading-relaxed">
              This ticket has been deleted and is no longer available.
            </span>
          </>
        ) : (
          <>
            <Lock className="w-16 h-16 text-gray-400 mb-3" />
            <span className="text-xl font-semibold text-gray-900 dark:text-gray-100">
              Access Required
            </span>
            <span className="text-base text-gray-600 dark:text-gray-300 leading-relaxed">
              You don't have access to this application yet. Please contact your administrator to
              request access and be assigned the appropriate role.
            </span>
          </>
        )}
        {!deleted && canAccessSettings && (
          <>
            <span className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
              As a platform administrator, you can assign yourself a role in Access Management.
            </span>
            <div className="flex gap-4 mt-3">
              <SkyButton
                appearance="primary"
                icon={UserCog}
                onClick={() => navigate("/dashboard/settings/roles" + getQueryString())}
              >
                Go to Access Management
              </SkyButton>
            </div>
          </>
        )}
      </SkyCard>
    </div>
  );
}
